import { permissionsHierarchy } from '../constants/permissionsHierarchy';

export const checkPermission = (userPermissions, code) => {
    // Check a list of permissions
    if (Array.isArray(code)) {
        return code.some((permissionCode) => userPermissions?.find((item) => item.code === permissionCode));
    }

    // Check just one permission
    return userPermissions?.find((item) => item.code === code);
};

export const redirectAfterLogin = (userPermissions) => {
    for (let i = 0; i < permissionsHierarchy.length; i++) {
        const permission = permissionsHierarchy[i];
        let found = userPermissions.find((userPermission) => userPermission.code === permission.code);
        if (found) {
            return permission.to;
        }
    }

    return '';
};

export const checkReportPermissions = (userPermissions) => {
    const reportPermissions = [
        'view_financial_report',
        'view_movements_report',
        'view_minimums_report',
        'view_stock_report',
        'view_work_order_reports',
    ];
    return userPermissions.some((permission) => reportPermissions.includes(permission.code));
};
